import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { ContentService as CourseService } from 'src/app/views/content/content.service';

export const firstLectureRedirectGuard: CanActivateFn = async (route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> => {
  const courseService = inject(CourseService);
  const router = inject(Router);
  const courseId = route.params['course'];

  // If there's no courseId, we can't do anything, so let the navigation continue.
  if (!courseId) {
    return true;
  }

  try {
    // Fetch the course data using the service method you provided.
    // Since it now returns a Promise, we can await it directly.
    // const course = await courseService.getTheCourse(courseId);
    const course = await firstValueFrom(courseService.getTheCourse(courseId));

    // Check for solo lectures first.
    if (course?.lectures?.[0]) {
      const firstLectureId = course.lectures[0]._id;
      return router.createUrlTree(['/knowledge', 'displayer', courseId, 'lectures', firstLectureId]);
    }
    // If no solo lectures, check for lectures in sections.
    else if (course?.sections?.[0]?.lectures?.[0]) {
      const firstSectionId = course.sections[0]._id;
      const firstLectureId = course.sections[0].lectures[0]._id;

      // Create the redirect UrlTree to the displayer component.
      return router.createUrlTree(['/knowledge', 'displayer', courseId, firstSectionId, firstLectureId]);
    } else {
      // If the course has no lectures at all, allow navigation to the overview page to proceed.
      return true;
    }
  } catch (error) {
    console.error('Error fetching course in redirect guard:', error);
    // As a safe fallback in case of an error, also allow navigation to the overview page.
    return true;
  }
};
